import React from 'react';
import { DynamicError } from '@askporter/component-library/Dynamic';
import { Loading } from '@askporter/component-library/Loading';
import { ThemeProvider } from '@askporter/component-library/theme';
import { BrowserRouter } from 'react-router';
import { ConfigProvider as AskPorterConfigProvider, getErrorStrings, useTranslation } from '@askporter/config-provider';
import CoreNavigation from '../../components/CoreNavigation';
import MaintenancePage from '../../pages/MaintenancePage';
interface ConfigProviderProps {
  children: React.ReactNode[] | React.ReactNode;
}
const ConfigProvider = ({ children }: ConfigProviderProps): JSX.Element => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const errorPageComponent = (
    <>
      <ThemeProvider>
        <BrowserRouter>
          {<DynamicError navigation={<CoreNavigation />} t={t} language={language} {...getErrorStrings()} />}
        </BrowserRouter>
      </ThemeProvider>
    </>
  );
  return (
    <AskPorterConfigProvider
      errorPageComponent={errorPageComponent}
      loadingComponent={<Loading />}
      codeSpecificErrorPages={[{ code: 503, component: <MaintenancePage shouldShowStaticErrorPage /> }]}
    >
      {children}
    </AskPorterConfigProvider>
  );
};
export default ConfigProvider;
